
import { AppInstancesRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';

const _directiveDependencies = ['Templates'];
const _controllerDependencies = ['Util', '$scope', 'DeploymentUrlsRestService', '$timeout', '$window'];

class PcDownloadDeploymentSuccessController {

    constructor(Util, $scope, DeploymentUrlsRestService, $timeout, $window) {

        this.$scope = $scope;
        this.Util = Util;
        this.DeploymentUrlsRestService = DeploymentUrlsRestService;
        this.$timeout = $timeout;
        this.$window = $window;
        this.$scope.isStep2Finished = false;
        this.$scope.isStep3Finished = false;

        // if user move mouse outside of browser we will mark that run program step is started
        this.addEvent(document, 'mouseout', (e) => {

            e = e || window.event;
            const from = e.relatedTarget || e.toElement;
            if (!from || from.nodeName === 'HTML') {

                this.$timeout(() => {

                    this.$scope.isStep2Finished = true;

                }, 3000);

            }

        });

        // when the app instance repo is updated it means user have succesful install the app,
        // then checkmark the install step
        const appInstancesObservable = AppInstancesRepository.getObservable();
        const appInstancesSubscriber = appInstancesObservable
            .subscribe(
                data => this.appInstancesNext(data),
                () => { },
                () => { },
            );

        $scope.$on('$destroy', () => {

            appInstancesSubscriber.dispose();

        });

        this.triggerInstall = false;

        // click handler for link to redeploy on current device
        // timeout hack is used to make sure the dom has been loaded
        this.$timeout(() => {

            const deployViaDownloadElement = angular.element(document.querySelector('#deployActionDownload'));
            deployViaDownloadElement.on('click', () => this.deployViaDownload());

        }, 0);

    }

    appInstancesNext() {

        if (this.triggerInstall) {

            this.$timeout(() => {

                this.$scope.isStep3Finished = true;

            }, 0);

        }
        this.triggerInstall = true;

    }
    // add event to the obj param
    addEvent(obj, evt, fn) {

        if (obj.addEventListener) {

            obj.addEventListener(evt, fn, false);

        } else if (obj.attachEvent) {

            obj.attachEvent(`on ${evt}`, fn);

        }

    }

    deployViaDownload() {

        const deploymentPayload = {
            appId: this.$scope.inputData.appId,
            license_type: (this.licenseId !== '') ? 'paid' : 'free',
            download_source: (this.licenseId !== '') ? 'wdp' : 'wdf',
            license_number: this.licenseId,
            beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
            os: this.$scope.inputData.os,
        };

        this.DeploymentUrlsRestService.deploy(deploymentPayload).then((response) => {

            const downloadUrl = this.Util.deepFind(response, 'data.data.attributes.download_url');

            if (downloadUrl) {

                this.$window.location.href = downloadUrl;

            }

        }, () => {

            Alert.error({
                message: 'cw.modal.server-error.desc',
                icon: {
                    cssClasses: 'icon-pc',
                },
            });
            this.Util.closeModal();

        });

    }

}

class PcDownloadDeploymentSuccessDirective {

    constructor() {

        this.template = require('./pc-download-deployment-success.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push((Util, $scope, DeploymentUrlsRestService, $timeout, $window) =>
            new PcDownloadDeploymentSuccessController(
                Util, $scope, DeploymentUrlsRestService,
                $timeout, $window,
            ));

        this.controller = _controllerDependencies;
        this.controllerAs = 'PcDownloadDeploymentSuccessCtrl';

    }

}

_directiveDependencies.push(() =>
    new PcDownloadDeploymentSuccessDirective());

angular.module('directives')
    .directive('pcDownloadDeploymentSuccess', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/pc-download-deployment-success/pc-download-deployment-success.js